export default __webpack_public_path__ + "static/media/company_1.023d0435.jpg";